import {
    Container,
    MainContentWrapper,
    MainContent,
    Heading
} from '../../../styles/account/account'
import { DashboardWrapper } from '../../../container/dashboardWrapper'
import { Input } from '../../../components/input'
import { InputWrapper } from '../../../components/input/input.style'
import { Button } from '../../../components/button'
import { Breadcrumb } from '../../../components/breadcrumb/breadcrumb'

const AccoountEditScreen = () => {
    return (
        <DashboardWrapper>
            <MainContentWrapper fullHeight>
                <Container>
                    <MainContent>
                        <Heading>
                            Account
                        </Heading>
                        <Breadcrumb
                            crumbs={['account', 'edit']}
                        />
                        <form>
                            <InputWrapper>
                                <Input
                                    id="firstName"
                                    label="First Name"
                                    type="text"
                                    placeholder="First Name"
                                    fullWidth
                                />
                            </InputWrapper>
                            <InputWrapper>
                                <Input
                                    id="lastName"
                                    label="Last Name"
                                    type="text"
                                    placeholder="Last Name"
                                    fullWidth
                                />
                            </InputWrapper>
                            <InputWrapper>
                                <Input
                                    id="emailAddress"
                                    label="Email address"
                                    type="email"
                                    placeholder="Email address"
                                    fullWidth
                                />
                            </InputWrapper>
                            <InputWrapper className="grid-2-2">
                                <Input
                                    id="mobileNumber"
                                    label="Mobile Number"
                                    type="text"
                                    placeholder="Mobile Number"
                                    fullWidth
                                />
                                <Input
                                    id="otherNumber"
                                    label="other number"
                                    type="text"
                                    placeholder="Other Number"
                                    fullWidth
                                />
                            </InputWrapper>
                            <InputWrapper>
                                <Input
                                    id="facebookUrl"
                                    label="facebook url"
                                    type="text"
                                    placeholder="Facebook Url"
                                    fullWidth
                                />
                            </InputWrapper>
                            <Button
                                type="submit"
                                style={{ marginLeft: 'auto' }}
                                variant="secondary"
                                responsive
                            >
                                SAVE CHANGES
                            </Button>
                        </form>
                    </MainContent>
                </Container>
            </MainContentWrapper>
        </DashboardWrapper>
    )
}

export default AccoountEditScreen